<div id="delete-account">
    <h2 class="title">Delete account</h2>
    <span class="description">If you want to delete your account, <b>enter your username</b> into the field below and press the button.</span>
    <p><input id="input-username-delete-account" type="text" placeholder="Enter Username..."></p>
    <p><button id="btn-delete-account">Delete my account!</button></p>
</div>